import type { OwnerReview } from '~/contracts/vdp';
import type { ResponseReview } from '~/services/vdp/contracts';
import escapeHTML from '~/utilities/escapeHTML';

export const sanitizeReviews = (reviews: OwnerReview[]): OwnerReview[] =>
  reviews.map(review => ({
    ...review,
    reviewText: escapeHTML(review.reviewText),
    vehicleDescription: escapeHTML(review.vehicleDescription)
  }));

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const highlightSearchTerms = (
  reviews: OwnerReview[],
  searchTerm: string
): OwnerReview[] => {
  if (!searchTerm) {
    return reviews;
  }

  // Escape metacharacters (avoid throws/ReDoS on user input) and compile once, reused per review.
  const pattern = new RegExp(
    '(' + escapeRegExp(searchTerm).replace(/\s+/g, '|') + ')',
    'gi'
  );
  const highlight = (text: string): string =>
    text.replace(pattern, '<span class="text-text-inverse bg-black">$1</span>');

  return reviews.map(review => ({
    ...review,
    reviewText: highlight(review.reviewText),
    vehicleDescription: highlight(review.vehicleDescription)
  }));
};

const formatReviewDate = (date: string): string => {
  const parsed = new Date(date);
  const month = parsed.getUTCMonth() + 1;
  const year = parsed.getUTCFullYear();

  return month < 10 ? `0${month}/${year}` : `${month}/${year}`;
};

export const mapReviewProperties = (reviews: ResponseReview[]): OwnerReview[] =>
  reviews.map(review => ({
    id: review.review_id,
    isVerified: true,
    ownerName: review.customer.name,
    ownerState: review.customer.state?.trim(),
    reviewDate: review.review_date
      ? formatReviewDate(review.review_date)
      : undefined,
    reviewRating: review.review_rating,
    reviewText: review.review_text,
    vehicleDescription: `${review.vehicle.year} ${review.vehicle.vehicle_make_model}`
  }));
